import { Autocomplete, AutocompleteChangeDetails, Button, Grid, TextField, Tooltip } from '@mui/material';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { resetSurveyorInput, setSurveyorInputExpand, setSelectedSurveyorId, setTriggerFocusCompanyNameInput, setSurveyorInput, setCountry, setSurveyorName, setContactDetailsAndCost, setPorts, setRemark } from './reducers/SurveyorInputReducer';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { SurveyorInputSelector } from './reducers/SurveyorInputReducer';
import SurveyorApi from './api/SurveyorApi';
import SurveyorModel from './models/SurveyorModel';
import { contactInputSelector } from '../Contact/reducers/ContactInputReducer';
import SurveyorSelector from '../SurveyorSelector/SurveyorSelector';
import { CountryModel } from '../Contact/models/ContactStaticResourcesModel';
import PortMultipleSelector from '../PortSelector/PortMultipleSelector';
import PortModel from '../PortSelector/models/PortModel';
import { portSelectorSelector } from '../PortSelector/reducers/PortSelectorReducer';

const SurveyorInput: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const SurveyorInputViewData = useSelector(SurveyorInputSelector);
    const contactInputViewData = useSelector(contactInputSelector);
    let portSelectorData = useSelector(portSelectorSelector);

    useEffect(() => {
        if (SurveyorInputViewData.triggerSave > 0) {
            save();
        }
    }, [SurveyorInputViewData.triggerSave]);

    useEffect(() => {
        if (SurveyorInputViewData.triggerRefreshInput > 0) {
            refreshInput();
        }
    }, [SurveyorInputViewData.triggerRefreshInput]);

    const refreshInput = () => {
        dispatch(resetSurveyorInput());
        dispatch(setSelectedSurveyorId(""));
        dispatch(setTriggerFocusCompanyNameInput((new Date()).getTime()));
    }

    useEffect(() => {
        if (SurveyorInputViewData.selectedSurveyorId.length > 0) {
            selectSurveyorById(SurveyorInputViewData.selectedSurveyorId);
        }
    }, [SurveyorInputViewData.selectedSurveyorId])

    const selectSurveyorById = (id: string) => {
        dispatch(showLoading(true));
        SurveyorApi.GetById({
            id: id
        }).then((response: BaseResponse<SurveyorModel>) => {
            if (response.success) {
                dispatch(setSurveyorInput(response.data));

                dispatch(showLoading(false));

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    };

    const portsToIds = (ports: PortModel[]) => {
        return _.map(ports, (port) => {
            return port.id
        })
    }

    const getPortsByIds = (portIds: number[]) => {
        return _.filter(portSelectorData.ports, (port) => {
            return _.indexOf(portIds, port.id) > -1;
        })
    }



    const save = () => {
        try {
            validate();

            SurveyorApi.Save(SurveyorInputViewData.SurveyorInput)
                .then((response: BaseResponse<SurveyorModel>) => {
                    if (response.success) {
                        if (SurveyorInputViewData.SurveyorInput.id.length === 0) {
                            Utility.Alert.Success("Surveyor added successful");
                        } else {
                            Utility.Alert.Success("Surveyor updated successful");
                        }

                        refreshInput();
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            Utility.Alert.Error(error);
        }
    }

    const validate = () => {
        if (SurveyorInputViewData.SurveyorInput.name.length === 0) {
            throw "Surveyor name is required";
        }

        if (SurveyorInputViewData.SurveyorInput.contactDetailsAndCost.length === 0) {
            throw "Contact details is required";
        }
    }

    const getCountry = () => {
        let country = _.find(contactInputViewData.staticResources.countries, (country) => {
            return country.code === SurveyorInputViewData.SurveyorInput.country
        })

        return country ? country : null;
    }

    return (
        <>
            {
                <CustomAccordion
                    title="Input"
                    defaultOpen={true}
                    className="top-quick-input"
                    open={SurveyorInputViewData.SurveyorInputExpand}
                    onOpenChange={(isOpen: boolean) => {
                        dispatch(setSurveyorInputExpand(isOpen));
                    }}
                >
                    <Grid container>
                        <Grid item lg={3} xs={12}>
                            <Grid container className='cargo-input-component'>
                                <Grid xs={10} lg={9}>
                                    <TextField
                                        label="Company Name"
                                        fullWidth
                                        value={SurveyorInputViewData.SurveyorInput.name ? SurveyorInputViewData.SurveyorInput.name : ""}
                                        onChange={(event) => {
                                            dispatch(setSurveyorName(event.target.value));
                                        }}
                                        className='cargo-input-component tonnage-input-full-tc'
                                    />
                                </Grid>
                                <Grid item xs={2} lg={3}>
                                    <Tooltip title="Reset (Alt + R)">
                                        <Button
                                            className="clear-input-button"
                                            tabIndex={-1}
                                            color="success"
                                            variant="contained"
                                            onClick={() => {
                                                refreshInput();
                                            }}
                                        >
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <Autocomplete
                                className='cargo-input-component'
                                options={contactInputViewData.staticResources.countries}
                                getOptionLabel={(option: CountryModel) => {
                                    return option.name + "(" + option.code + ")"
                                }}
                                renderInput={(params) => <TextField {...params} label="Country" />}
                                value={getCountry()}
                                onChange={(event: React.SyntheticEvent, value: CountryModel | null, reason: string, details?: AutocompleteChangeDetails<CountryModel> | undefined) => {
                                    dispatch(setCountry(value ? value.code : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <PortMultipleSelector
                                onPortChange={(value: PortModel[]) => {
                                    if (value) {
                                        dispatch(setPorts(portsToIds(value)));
                                    }
                                }}
                                useFreeText={true}
                                portLabel='Port Open'
                                hideArea={true}
                                portValues={getPortsByIds(SurveyorInputViewData.SurveyorInput.ports)}
                                className='cargo-input-component'
                                useAreaBookmark={true}
                            >
                            </PortMultipleSelector>
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                label="Contact Details"
                                multiline
                                fullWidth
                                rows={3}
                                value={SurveyorInputViewData.SurveyorInput.contactDetailsAndCost}
                                onChange={(event) => {
                                    dispatch(setContactDetailsAndCost(event.target.value ? event.target.value : ""));
                                }}
                                className='cargo-input-component tonnage-input-full-tc'
                            />
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                label="Remark"
                                multiline
                                fullWidth
                                rows={3}
                                value={SurveyorInputViewData.SurveyorInput.remark}
                                onChange={(event) => {
                                    dispatch(setRemark(event.target.value ? event.target.value : ""));
                                }}
                                className='cargo-input-component tonnage-input-full-tc'
                            />
                        </Grid>
                        <Grid item lg={1} xs={12}>
                            <Tooltip title="Alt + S">
                                <Button
                                    onClick={save}
                                    variant="outlined"
                                >
                                    Save (s)
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </CustomAccordion>
            }
        </>
    )
};

export default SurveyorInput;